<template>
	<div class="main_div" id="script">
		<sui-message warning v-if="isSlowNetwork" class="slow-network-banner">
			<sui-icon name="exclamation triangle" />
			Tu conexión a internet es lenta y puede afectar el funcionamiento del sistema.
		</sui-message>
		<router-view></router-view>
	</div>
</template>
<script setup>
	import { ref, onMounted, onBeforeUnmount } from "vue";
	import { startNetworkSpeedMonitor } from "./utils/networkSpeed";

	const page_title = process.env.VUE_APP_PAGE_NAME;
	const isSlowNetwork = ref(false);
	let stopNetworkMonitor = null;

	onMounted(() => {
		document.title = page_title;
		stopNetworkMonitor = startNetworkSpeedMonitor((isSlow) => {
			isSlowNetwork.value = isSlow;
		});
	});

	onBeforeUnmount(() => {
		if (stopNetworkMonitor) stopNetworkMonitor();
	});
</script>
<style>
.main_div{
	padding: 0;
	margin: 0;
	width: 100%;
	min-height: 100vh;
	background-color: rgb(240,240,240) !important;
	padding-bottom: 50px;
}

.slow-network-banner{
	margin: 10px 15px 0;
}

#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

nav {
	padding: 30px;
}

nav a {
	font-weight: bold;
	color: #2c3e50;
}

nav a.router-link-exact-active {
	color: #42b983;
}


.ui.message:empty{
	display: none;
}
</style>
